import { render, staticRenderFns } from "./Ponderacion.vue?vue&type=template&id=e760f4e2&scoped=true"
import script from "./Ponderacion.vue?vue&type=script&lang=js"
export * from "./Ponderacion.vue?vue&type=script&lang=js"
import style0 from "./Ponderacion.vue?vue&type=style&index=0&id=e760f4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e760f4e2",
  null
  
)

export default component.exports